import store from '@/store';
import useRecentBanners from '@/components/messageManager/ImagePicker/hooks/useRecentBanners';
import useRecentCards from '@/components/messageManager/ImagePicker/hooks/useRecentCards';
import * as OrderSessionManager from '@/utils/OrderSessionManager';
import * as jwt from 'jsonwebtoken';
import { unref } from '@vue/composition-api';

export function checkAuthorization(to, from, next) {
	if (!store.getters.isLoggedIn) {
		next({
			name: 'login',
			params: {
				...to,
			},
		});
		return;
	}
	next();
}

export async function subMemberCheckAuthorizationMaster(to, from, next) {
	if (!store.getters.isLoggedIn) {
		next({
			name: 'login',
			params: {
				...to,
			},
		});
		return;
	}

	if (!store.getters.isMasterMember) {
		await store.dispatch('updateUserInfo');
		if (!store.getters.isMasterMember) {
			next({ path: '/404' });
			return;
		}
	}

	next();
}

export function checkedUserHasEverLoggedIn(to, from, next) {
	if (store.getters.isLoggedIn && store.getters.userInfo) {
		next({
			name: 'home',
			params: {
				...to,
			},
		});
		return;
	}
	next();
}

export async function checkPaymentResult(to, from, next) {
	const JWT_KEY = '00000000000000000000000000000001';
	const recentCards = useRecentCards();
	const recentBanners = useRecentBanners();
	const orderGoods = store.getters['order/orderState'].orderGoods;

	const addRecentCardAndBanner = () => {
		orderGoods.forEach(({ bannerId, bannerImg, templateId, templateImg }) => {
			if (templateId && templateImg) {
				recentCards.add({
					cardImageUrl: templateImg,
					templateId,
				});
			}
			if (bannerId && bannerImg) {
				recentBanners.add({
					bannerImageUrl: bannerImg,
					templateId: bannerId,
				});
			}
		});
	};

	const { result } = to.query;

	try {
		const {
			sessionId,
			orderNo,
			bSucc,
			bizchargeFlag,
			res_cd,
			res_msg,
			payMethod,
			vAmount,
			vBankname,
			vAccount,
			vDepositor,
			vADate,
			chargeMoney,
			cardBillUrl,
		} = jwt.verify(result, JWT_KEY);

		/** 결제 */
		if (bSucc === 'true' && bizchargeFlag === 'false') {
			OrderSessionManager.closeSession(unref(sessionId));
			addRecentCardAndBanner();

			next({
				name: 'orderSuccess',
				query: {
					orderNo,
				},
			});
			return;
		}

		/** 비즈머니 충전 */
		if (bSucc === 'true' && bizchargeFlag === 'true') {
			if (payMethod === 'VIAC') {
				next({
					name: 'bizmnchargeendacc',
					query: {
						orderNo,
						vAmount,
						vBankname,
						vAccount,
						vDepositor,
						vADate,
					},
				});
				return;
			}

			if (payMethod !== 'VIAC') {
				next({
					name: 'bizmnchargeend',
					query: {
						orderNo,
						chargeMoney,
						cardBillUrl,
						payMethod,
					},
				});
				return;
			}
		}

		next({
			name: 'paymenterror',
		});
	} catch (e) {
		next({
			name: 'paymenterror',
		});
	}
}
